/******/ (() => { // webpackBootstrap
  var __webpack_exports__ = {};
  /* eslint-disable */

  window.PXUTheme.jsFreeShipping = {
    freeShippingThreshold: 9500, // $95.00 in cents (adjust as needed)

    init: function () {
      // Update free shipping on page load
      this.updateFreeShippingDisplay();
      
      // Hook into cart changes
      this.attachCartListeners();
    },

    attachCartListeners: function () {
      const self = this;

      // Listen for delete button clicks
      $(document).on('click', '[data-ajax-cart-delete], .ajax-cart__delete', function () {
        // Delay to allow the cart to update first
        setTimeout(() => {
          self.updateFreeShippingDisplay();
        }, 600);
      });

      // Listen for plus/minus control clicks
      $(document).on('click', '.control.plus-control, .control.minus-control', function () {
        // Delay to allow the cart to update first
        setTimeout(() => {
          self.updateFreeShippingDisplay();
        }, 500);
      });

      // Listen for quantity changes in ajax cart
      $(document).on('change', '.ajax-cart__quantity-box input[type="number"]', function () {
        const $input = $(this);
        const lineID = $input.closest('[data-line-item]').data('line-item');
        const newQuantity = parseInt($input.val());

        self.updateCartQuantity(lineID, newQuantity);
      });

      // Listen for quantity changes on cart page
      $(document).on('change', '.cart__quantity-box input[type="number"]', function () {
        const $input = $(this);
        const lineID = $input.closest('[data-line-item]').data('line-item');
        const newQuantity = parseInt($input.val());

        self.updateCartQuantity(lineID, newQuantity);
      });

      // Alternative: Listen for any clicks on elements with 'plus' or 'minus' in class
      $(document).on('click', '[class*="plus"], [class*="minus"]', function () {
        // Check if this is a quantity control
        if ($(this).closest('.quantity-box, .ajax-cart__quantity-box, .cart__quantity-box').length) {
          setTimeout(() => {
            self.updateFreeShippingDisplay();
          }, 500);
        }
      });
    },

    updateCartQuantity: function (lineID, quantity) {
      const self = this;

      $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        data: { quantity: quantity, line: lineID },
        dataType: 'json',
        success: function (cart) {
          self.updateFreeShippingFromCart(cart);
          
          // Trigger the existing update views
          if (typeof window.PXUTheme.jsAjaxCart !== 'undefined') {
            window.PXUTheme.jsAjaxCart.updateView();
          }
          if (typeof window.PXUTheme.jsCart !== 'undefined') {
            window.PXUTheme.jsCart.updateView(cart, lineID);
          }
        },
        error: function (XMLHttpRequest, textStatus) {
          console.error('Error updating cart quantity:', textStatus);
        }
      });
    },

    updateFreeShippingDisplay: function () {
      const self = this;

      // Fetch current cart state
      $.ajax({
        type: 'GET',
        url: '/cart.js',
        dataType: 'json',
        success: function (cart) {
          self.updateFreeShippingFromCart(cart);
        },
        error: function (XMLHttpRequest, textStatus) {
          console.error('Error fetching cart:', textStatus);
        }
      });
    },

    updateFreeShippingFromCart: function (cart) {
      const $freeShippingSection = $('.ajax-cart__free-shipping');
      
      // Show/hide free shipping section based on cart count
      if (cart.item_count === 0) {
        if ($freeShippingSection.length) {
          $freeShippingSection.addClass('is-hidden');
        }
        return; // Exit early if cart is empty
      }

      // Cart has items, make sure section is visible
      if ($freeShippingSection.length) {
        $freeShippingSection.removeClass('is-hidden');
      }

      const cartTotal = cart.total_price; // in cents
      const threshold = this.freeShippingThreshold;
      const remaining = Math.max(0, threshold - cartTotal);
      const progress = Math.min(100, (cartTotal / threshold) * 100);

      // Update progress bar
      const $progressBar = $('.ajax-cart__free-shipping-progress-bar');
      if ($progressBar.length) {
        $progressBar.css('width', progress + '%');
      }

      // Update text
      const $freeShippingText = $('.ajax-cart__free-shipping-text-rem');
      if ($freeShippingText.length) {
        if (remaining === 0) {
          $freeShippingText.html("You're getting free shipping!");
        } else {
          const remainingFormatted = this.formatMoney(remaining);
          $freeShippingText.html(`You are ${remainingFormatted} away`);
        }
      }
    },

    formatMoney: function (cents) {
      // Basic money formatting - adjust based on your shop's currency settings
      // This is a simple version; you may want to use Shopify's money format
      const dollars = (cents / 100).toFixed(2);
      return '$' + dollars;
    },

    // Hook this into existing cart operations
    hookIntoExistingCart: function () {
      const self = this;

      // Override or extend the existing removeFromCart in jsAjaxCart
      if (typeof window.PXUTheme.jsAjaxCart !== 'undefined') {
        const originalRemove = window.PXUTheme.jsAjaxCart.removeFromCart;
        window.PXUTheme.jsAjaxCart.removeFromCart = function (lineID, callback) {
          originalRemove.call(this, lineID, callback);
          // Update free shipping after removal
          setTimeout(() => {
            self.updateFreeShippingDisplay();
          }, 300);
        };

        const originalAddToCart = window.PXUTheme.jsAjaxCart.addToCart;
        window.PXUTheme.jsAjaxCart.addToCart = function ($addToCartForm) {
          const result = originalAddToCart.call(this, $addToCartForm);
          // Update free shipping after adding
          setTimeout(() => {
            self.updateFreeShippingDisplay();
          }, 1200);
          return result;
        };
      }

      // Override or extend the existing removeFromCart in jsCart
      if (typeof window.PXUTheme.jsCart !== 'undefined') {
        const originalCartRemove = window.PXUTheme.jsCart.removeFromCart;
        window.PXUTheme.jsCart.removeFromCart = function (lineID) {
          originalCartRemove.call(this, lineID);
          // Update free shipping after removal
          setTimeout(() => {
            self.updateFreeShippingDisplay();
          }, 300);
        };
      }
    }
  };

  // Initialize when document is ready
  $(document).ready(function () {
    if (typeof window.PXUTheme !== 'undefined') {
      window.PXUTheme.jsFreeShipping.init();
      window.PXUTheme.jsFreeShipping.hookIntoExistingCart();
    }
  });

/******/ })();

